import { gql } from '@apollo/client';
import { ReportSectionState } from '@mnd-frontend/graphql-schema';
import { GREY_900 } from '@mnd-frontend/ui/shared/tokens';
import type { Report2VisibilityMentionsOverTimeFragment } from '../../../../../generated/types';
import { MentionsOverTimeGraph } from '../../charts';
import { Insights, Section, SectionHeader } from '../../common';

export const REPORT2_VISIBILITY_MENTIONS_OVER_TIME_FRAGMENT = gql`
  fragment Report2VisibilityMentionsOverTime on ReportVisibilityMentionsOverTime {
    id
    title
    state
    groupBy
    mentionsOverTime {
      startAt
      endAt
      startAtPreviousYear
      endAtPreviousYear
      week
      month
      mentions
      mentionsPreviousYear
    }
    insights2 {
      id
      title
      insight
      insightType
    }
  }
`;

const VisibilityMentionsOverTime = ({
  section,
}: {
  section: Report2VisibilityMentionsOverTimeFragment;
}) => {
  const { groupBy, mentionsOverTime, insights2 } = section;
  return (
    <Section>
      <SectionHeader
        color={GREY_900}
        as="h3"
        variant="reportHeadlineLarge"
        section={section}
        isSubsection
      />
      <MentionsOverTimeGraph
        loading={section.state !== ReportSectionState.Done}
        groupBy={groupBy}
        mentionsOverTime={mentionsOverTime}
      />
      <Insights insights={insights2} />
    </Section>
  );
};

export default VisibilityMentionsOverTime;
